import { useState } from 'react';

const faqs = [
  {
    question: '不知火舞在哪些游戏作品中登场过？',
    answer:
      '不知火舞自1992年在《饿狼传说2》中首次登场以来，已先后出现在《饿狼传说》系列全部作品、《拳皇》系列（KOF 94至KOF XV）、《SNK VS. Capcom》系列、《死或生5/6》、《王者荣耀》（联动）、《无双大蛇》系列等超过30款游戏中，是游戏史上跨界出演次数最多的女性格斗角色之一。',
  },
  {
    question: '不知火舞最适合新手练习的连招是什么？',
    answer:
      '新手推荐从「跳C → 站C → 花蝶扇（236P）」这套基础连段开始练习。这套连段输入简单，伤害稳定，且花蝶扇命中后还有+3帧的有利状态，可以继续压制。熟练掌握后，可以进阶到「蹲B → 蹲A → 龙炎舞(轻) → 超必杀忍蜂」这套下段确认接超杀的经典连段。',
  },
  {
    question: '不知火舞在拳皇15中的强度如何？排位适合用吗？',
    answer:
      '在拳皇15当前版本中，不知火舞属于A级角色，强度中上。她的优势在于优秀的立回能力、稳定的连段伤害和低资源消耗。适合放在先锋位或中坚位使用。舞的上手难度适中，上限很高，无论是新手还是老手都能发挥出不错的效果。在高分段天梯中，舞也是许多选手的副角色首选。',
  },
  {
    question: '不知火舞和安迪·博加德到底是什么关系？',
    answer:
      '不知火舞对安迪·博加德一见钟情，展开了热烈的追求。安迪是不知火流的弟子，舞的祖父不知火半藏收养了安迪并教授他忍术。虽然安迪对舞也有感情，但他性格内敛、专注于修行，经常回避舞的热情表白。两人之间「你追我逃」的相处模式已经持续了三十多年，成为了格斗游戏中最经典的CP之一。在最新作品中，两人的关系似乎有了微妙进展。',
  },
  {
    question: '不知火舞有哪些最经典的必杀技？',
    answer:
      '不知火舞最具代表性的必杀技包括：花蝶扇（投掷折扇的远程牵制技）、龙炎舞（火焰升龙对空技）、超必杀忍蜂（火焰突进超杀）和凤凰之舞（全屏火焰超杀）。其中花蝶扇是舞的标志性招式，不仅是实战中的核心牵制技，也成为了她最具辨识度的视觉符号。在拳皇15中新增的「不知火流奥义·九尾」更是视觉冲击力十足的MAX终极奥义。',
  },
  {
    question: '本站的内容是官方授权的吗？',
    answer:
      '拳皇档案馆是一个由格斗游戏爱好者自发创建和维护的粉丝内容站点，与SNK Corporation无任何关联。本站所有攻略内容均为玩家社区原创编写，旨在为格斗游戏爱好者提供参考与交流的平台。角色版权归SNK Corporation所有。如您对内容有任何疑问或建议，欢迎通过关于我们页面中的联系方式与我们取得联系。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题解答
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            关于不知火舞，你可能想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors duration-200 ${
                  openIndex === index
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200/70 text-foreground-500'
                }`}>
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-sm`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}